module.exports = __webpack_public_path__ + "static/media/hacker.86246d47.svg";